import { setActiveIndex } from "./activeIndex";
import { highlightActiveRoomsOnMap } from "./highlightActiveRoomsOnMap";
import { resetLoopCount } from "./loopCount";
import { resetMapInterval } from "./mapInterval";
import { resetMapTimeout } from "./mapTimeout";
import { removeAllHighlights } from "./removeAllHighlights";
import { roomInteractions } from "./roomInteraction";
import { setRoomsRendered } from "./roomsRendered";
export function resetMap() {
    resetMapTimeout();
    resetMapInterval();
    setRoomsRendered(
    // TODO: Do we need to do this querySelector every time we reset?
    [
        ...document.querySelectorAll(".map-content .room"),
    ]);
    resetLoopCount();
    removeAllHighlights();
    highlightActiveRoomsOnMap(setActiveIndex(0));
    document.removeEventListener("click", roomInteractions);
}
